import angular from 'angular';

import GenderGroup from '@front10/healthcare-book/src/app/common/gender-group/gender-group.module';
import DateGroup from '@front10/healthcare-book/src/app/common/date-group/date-group.module';
import AdvancedSearch from '@front10/healthcare-book/src/app/components/doctor-advance-filter-options/doctor-advance-filter-options.module';
import DateSelector from '@front10/healthcare-book/src/app/components/date-selector/date-selector.module';
import DoctorAppointmentCard from '@front10/healthcare-book/src/app/components/doctor-appointments-card/doctor-appointments-card.modules';

import HealthcarebookComponentsComponent from './components.component';

export default angular.module('healthcarebookComponents', [GenderGroup, DateGroup, AdvancedSearch, DateSelector, DoctorAppointmentCard])
    .component('healthcarebookComponentsComponent', HealthcarebookComponentsComponent)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/components/components.module.js
// module id = 342
// module chunks = 0